export default "__VITE_ASSET__BNXeYA7A__"